var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.69036C16.7189 4.47149 16.9787 4.29787 17.2647 4.17942C17.5506 4.06097 17.8571 4 18.1667 4C18.4762 4 18.7827 4.06097 19.0687 4.17942C19.3546 4.29787 19.6145 4.47149 19.8333 4.69036C20.0522 4.90923 20.2258 5.16906 20.3443 5.45503C20.4627 5.741 20.5237 6.04749 20.5237 6.35702C20.5237 6.66655 20.4627 6.97305 20.3443 7.25902C20.2258 7.54498 20.0522 7.80482 19.8333 8.02369L8.58333 19.2737L4 20.5237L5.25 15.9404L16.5 4.69036Z",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2978db0aabcedca85e4225879b8df94f.svg";
export { ForwardRef as ReactComponent };